module.exports = __webpack_public_path__ + "img/2.c9b5b1f8.jpg";